/* eslint-disable */
import { getStoredToken } from '../../utils/auth';

export const BASE_URL = 'https://api.smartdriving.io';
export const AUTH_URL = 'https://auth.smartdriving.io/api/sms/Login';
export const SUCCESS_URL = 'https://static.smartdriving.io/html/success.html';
export const FAIL_URL = 'https://static.smartdriving.io/html/fail.html';

export const apiAuthRequest = (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  };

  return fetch(AUTH_URL, requestOptions).then((response) => {
    if (response.status === 200) {
      return response.json();
    }
    return Promise.reject(response);
  });
};

export const checkUserExistRequest = (params) => {
  return fetch(`https://auth.smartdriving.io/api/sms/DoesUserExist?phone=${params.phone}`).then((response) => {
    if (response.status === 200) {
      return response.json().then(userExists => userExists);
    }
    return Promise.reject(response);
  });
};

export const resetPasswordRequest = (options) => {
  return fetch('https://auth.smartdriving.io/api/sms/RequestResetPassword', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': options.params.Language,
    },
    body: JSON.stringify(options.phone),
  }).then((response) => {
    if (response.status === 200) {
      return response.json();
    }
    return Promise.reject(response);
  });
};

export const apiRefreshAuthRequest = (params) => {
  return fetch(`https://auth.smartdriving.io/api/Refresh/${params.refresh_token}`).then((response) => {
    if (response.status === 200) {
      return response.json();
    }
    return Promise.reject(response);
  });
};

export const geoCodeRequest = (params) => {
  return fetch('https://geocoder2.smartdriving.io/GeocodeMany', {
    method: 'POST',
    headers: {
      'Content-Type': 'text/plain'
    },
    body: params.body,
    params,
  }).then((response) => {
    if (response.status === 200) {
      return response.json();
    }

    return Promise.reject(response);
  });
};

export const apiRequest = (options) => {
  const tokenInfo = getStoredToken() || {};
  // if (!tokenInfo) {
  //   throw new Error('No access_token present!');
  // }
  const accessToken = tokenInfo.access_token;

  let requestOptions = {
    method: options.method || 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: options.body,
  };
  if(options && options.params && options.params.Language) {
    requestOptions.headers['Accept-Language'] = options.params.Language;
    delete options.params.Language;
  }

  let url = new URL(BASE_URL + options.url);
  if (options.params && requestOptions.method === 'GET') {
    const searchParams = new URLSearchParams();
    Object.keys(options.params).forEach((key) => {
      if (options.params[key] instanceof Array) {
        options.params[key].forEach((item) => {
          searchParams.append(key, item);
        });
      } else {
        searchParams.append(key, options.params[key]);
      }
    });

    url += `?${searchParams}`;
  }

  return fetch(url, requestOptions).then((response) => {
    if (response.status === 200) {
      const isDeviceActionPost = options.url.includes('/Run') || options.url.includes('/LockDoor') || options.url.includes('/SetServiceMode')
        || options.url.includes('/Register') || options.url.includes('/Mark') || options.url.includes('autorun')
        || options.url.includes('Webasto') || options.url.includes('/remove') || options.url.includes('/enable')
      || options.url.includes('/schedule/weekly') || options.url.includes('/profile') || options.url.includes('/wkt')
      || options.url.includes('/schedule/interval') || options.url.includes('/customName')
      || options.url.includes('/Appeal') || options.url.includes('/LockTrunk') ;
      if (isDeviceActionPost) {
        return response
      }
      return response.json()
    } else if (response.status !== 404) {
      try {
        JSON.parse(response.text());
        return response.json().then(e => Promise.reject(e))
      } catch (_) {
        return Promise.reject(response);
      }
    }

    return Promise.reject(response);
  });
};



// WEBPACK FOOTER //
// ./src/utils/api/index.js